<p-drawer
	[visible]="globalSidenavService.visible()"
	[closable]="false"
	(visibleChange)="globalSidenavService.visible.set($event)"
	class="bg-primary-200"
>
	<ng-template #header>
		<div class="flex flex-col w-full">
			<div class="w-100 flex justify-between items-center gap-2">
				<div class="flex flex-row gap-x-3">
					<p-avatar
						[image]="userService.user()!.personalData.profilePic"
						shape="circle"
						size="xlarge"
					/>
					<div class="flex flex-col justify-center items-start">
						<span class="font-bold">
							{{ userService.user()!.personalData.firstName }}
							{{ userService.user()!.personalData.lastName }}
						</span>
						<small class="font-extralight text-[10px]">
							{{ userService.user()!.email }}
						</small>
					</div>
				</div>
				<button
					pButton
					type="button"
					[outlined]="true"
					(click)="
						globalSidenavService.visible.set(false); editProfile()
					"
				>
					<i class="pi pi-user-edit"></i>
				</button>
			</div>
			<p-divider />
		</div>
	</ng-template>

	<div class="flex flex-col justify-center items-center gap-3 w-100">
		@for (item of routes; track $index) {
		<button
			pButton
			[raised]="!item.outlined"
			[outlined]="item.outlined"
			(click)="
				globalSidenavService.visible.set(false); evalItemRoute(item)
			"
			style="width: 100%"
			[severity]="item.severity ?? 'primary'"
		>
			<i [class]="item.icon"></i>
			{{ item.label }}
		</button>
		} @if (['admin', 'staff'].includes(userService.user()!.role)) {
		<button
			pButton
			[raised]="true"
			routerLink="/admin"
			(click)="globalSidenavService.visible.set(false)"
			style="width: 100%"
			severity="secondary"
		>
			<i class="pi pi-cog"></i>
			Admin
		</button>
		}
	</div>

	<ng-template #footer>
		<div class="flex items-center gap-2">
			<button
				pButton
				label="Cerrar Sesión"
				class="w-full"
				severity="danger"
				text
				(click)="logout(); globalSidenavService.visible.set(false)"
			>
				<i class="pi pi-sign-out"></i>
			</button>
		</div>

		<app-registered-mark />
	</ng-template>
</p-drawer>
